module.exports = __webpack_public_path__ + "img/x-logo.2b4ef6d1.svg";